export default "__VITE_ASSET__FzOGmWB8__"